import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useWatcherButton } from './useWatcherButton';
import { PrimaryButton } from '../../../components/button';
import { DeleteWatcherButton } from '../../../watchers/components/delete-watcher-button/DeleteWatcherButton';
import styles from './search_decision_watcher.module.scss';
import { useDecisionWatcherModal } from './useDecisionWatcherModal';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';

export const SearchDecisionWatcher: FC = () => {
  const source = 'create_search_decision_watcher';
  const [createWatcher, isWatched, deleteWatcher] = useWatcherButton({
    source,
  });
  const openModal = useDecisionWatcherModal({ createWatcher });
  const { openRestrictedModal } = useRestrictedModal();
  const { accessPremium } = useUser();

  const createDecisionWatcher = () => {
    if (accessPremium) {
      openModal();
    } else {
      openRestrictedModal({ source });
    }
  };

  return (
    <div className={styles.container}>
      {!isWatched && (
        <PrimaryButton
          iconLeft="notifications_none"
          dataName="add-decision-watcher"
          onClick={createDecisionWatcher}
        >
          <FormattedMessage id="search/components/search-watcher/SearchDecisionWatcher.tsx/1" />
        </PrimaryButton>
      )}
      {isWatched && (
        <DeleteWatcherButton
          place="bottom"
          deleteWatcher={deleteWatcher}
          tooltipId="search-decision-watcher-button"
        />
      )}
    </div>
  );
};
